'use strict';

Object.defineProperty(exports, '__esModule', {
  value: true
});
var _extends = require('@babel/runtime/helpers/extends');
var _objectWithoutProperties = require('@babel/runtime/helpers/objectWithoutProperties');
var react = require('@chakra-ui/react');
var utils = require('@chakra-ui/utils');
var React = require('react');
var alertContext = require('./alertContext.js');
function _interopDefaultLegacy(e) {
  return e && typeof e === 'object' && 'default' in e ? e : {
    'default': e
  };
}
var _extends__default = /*#__PURE__*/_interopDefaultLegacy(_extends);
var _objectWithoutProperties__default = /*#__PURE__*/_interopDefaultLegacy(_objectWithoutProperties);
var React__default = /*#__PURE__*/_interopDefaultLegacy(React);
var _excluded = ["children", "as"];
function AlertIcon(props) {
  var children = props.children,
    as = props.as,
    rest = _objectWithoutProperties__default["default"](props, _excluded);
  var _useAlertContext = alertContext.useAlertContext(),
    status = _useAlertContext.status;
  var BaseIcon = alertContext.getStatusIcon(status);
  var styles = alertContext.useAlertStyles();
  var css = status === 'loading' ? styles.spinner : styles.icon;
  if (!BaseIcon && !children && !as) return null;
  return /*#__PURE__*/React__default["default"].createElement(react.chakra.span, _extends__default["default"]({
    display: "inherit"
  }, rest, {
    className: utils.cx('chakra-alert__icon', props.className),
    __css: css,
    as: as
  }), children || BaseIcon && /*#__PURE__*/React__default["default"].createElement(BaseIcon, {
    h: "100%",
    w: "100%",
    color: "inherit"
  }));
}
AlertIcon.displayName = 'AlertIcon';
exports.AlertIcon = AlertIcon;